module.exports = __webpack_public_path__ + "img/aimgroup2.b51b4daa.png";